import { SalePriceInput } from "@/components/catalog/SalePriceField";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

type Props = {
  value: number | null | undefined;
  onChange: (value: number | null) => void;
  id?: string;
  label?: string;
  subLabel?: string;
  labelTrailing?: ReactNode;
  hideLabel?: boolean;
  /** Live Lac/Crore preview inside the input on the right. */
  shortLabelInside?: boolean;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  inputClassName?: string;
  labelClassName?: string;
  allowZero?: boolean;
  showShortLabelHint?: boolean;
};

/**
 * Money input for purchase/deal amounts: comma display + Lac/Crore shorthand.
 */
export function AmountField({
  value,
  onChange,
  id,
  label = "Amount",
  subLabel,
  labelTrailing,
  hideLabel = false,
  shortLabelInside = false,
  placeholder = "0",
  disabled,
  className,
  inputClassName,
  labelClassName,
  allowZero = false,
  showShortLabelHint = true,
}: Props) {
  return (
    <SalePriceInput
      id={id}
      value={value}
      onChange={(next) => {
        if (next == null && allowZero) onChange(0);
        else onChange(next);
      }}
      label={label}
      subLabel={subLabel}
      labelTrailing={labelTrailing}
      hideLabel={hideLabel}
      shortLabelInside={shortLabelInside}
      placeholder={placeholder}
      disabled={disabled}
      className={className}
      inputClassName={cn("glass-input", inputClassName)}
      labelClassName={labelClassName}
      showShortLabelHint={showShortLabelHint}
    />
  );
}
